import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { useBuybackEnabled } from '@backmarket/nuxt-layer-buyback/app/composables/useBuybackEnabled/useBuybackEnabled'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { ROUTE_NAMES } from '~/scopes/dashboard/constants'

import { toTradeInCards } from './useTradeInCards.helpers'

/**
 * Trade-in cards for the Help Center orders section: one card per buyback
 * order, tagged with its current timeline step.
 */
export function useTradeInCards() {
  const i18n = useI18n()
  const $httpFetch = useHttpFetch()
  const { isUserAuthenticated } = useUserStore()
  const { isRegularTradeInEnabled } = useBuybackEnabled()
  const resolveLocalizedRoute = useRouteLocationWithLocale()

  const { data: tradeIns, status } = useAsyncData(
    () =>
      $httpFetch('/bm/buyback/v1/customer/orders', {
        query: { page: 1 },
      }),
    { immediate: isUserAuthenticated.value && isRegularTradeInEnabled },
  )

  const isPending = computed(() => status.value === 'pending')

  const tradeInsPageTo = resolveLocalizedRoute({
    type: 'internal',
    name: ROUTE_NAMES.DASHBOARD.MY_SALES,
  })

  const tradeInCards = computed(() =>
    toTradeInCards(tradeIns.value?.results, { i18n, tradeInsPageTo }),
  )

  return { tradeInCards, isPending }
}
